<template>
  <div id="app">
    <div v-if="showGlobalSelector" class="global-user-type-bar">
      <div class="container-wrap">
        <user-type-selector />
      </div>
    </div>
    <router-view :key="routerViewKey" />
  </div>
</template>

<script>
import UserTypeSelector from './components/UserTypeSelector.vue';

export default {
  name: 'App',
  components: {
    UserTypeSelector,
  },
  computed: {
    routerViewKey() {
      const actingType = this.$store.getters.selectedUserType || 'default';
      const routeNameOrPath = this.$route.name || this.$route.path;
      const routeParams = JSON.stringify(this.$route.params || {});
      return `${routeNameOrPath}:${routeParams}:${actingType}`;
    },
    showGlobalSelector() {
      if (!this.$store.getters.isLoggedIn) return false;
      return !this.$route.matched.some((record) => record.meta.hideForAuth);
    },
  },
};
</script>

<style lang="scss">
@import "scss/app.scss";

.global-user-type-bar {
  position: sticky;
  top: 0;
  z-index: 50;
  background: #fff;
  border-bottom: 1px solid #eee;
  padding: 0.5rem 0.75rem;

  .container-wrap {
    max-width: 1200px;
    margin: 0 auto;
    display: flex;
    justify-content: center;
    align-items: center;
  }
}
</style>
